import { Modal, ModalContent, ModalOverlay } from '@chakra-ui/react';
import type { FullscreenPopup } from 'types/cms/Globals';

import { Animation } from './Animation';
import { Content } from './Content';
import { SkincareVideo } from './SkincareVideo';
import { Video } from './Video';
import { VideoContent } from './VideoContent';

type PopupProps = Pick<
  FullscreenPopup,
  'overlineText' | 'title' | 'link' | 'variant' | 'videos'
> & {
  isOpen: boolean;
  onClose: (action?: 'click' | 'close', url?: string) => void;
};

export function Popup({
  variant,
  videos,
  isOpen,
  onClose,
  ...props
}: PopupProps) {
  const contentProps = {
    ...props,
    onClose,
  };

  return (
    <Modal
      id="fullscreen-popup"
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={false}
    >
      <ModalOverlay background="rgba(255, 255, 255, 0.5)" zIndex={6} />
      <ModalContent
        aria-label={props.overlineText || 'Promotional popup'}
        maxW="100%"
        h="100%"
        position="relative"
        margin={0}
        overflowY="auto"
        padding={0}
      >
        {variant === 'video' && videos && <Video videos={videos} />}
        {variant === 'skincare' && <SkincareVideo />}
        {(variant === 'softgels' || variant === 'gummies') && (
          <Animation variant={variant} />
        )}
        {variant === 'video' ? (
          <VideoContent {...contentProps} />
        ) : (
          <Content {...contentProps} />
        )}
      </ModalContent>
    </Modal>
  );
}
